import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';

export class Route {
  protected loadingService = inject(LoadingService);

  constructor() {
    this.loadingService.hideLoader();
  }
}
